import { render, staticRenderFns } from "./InputParameterriskmanagement.vue?vue&type=template&id=35377967"
import script from "./InputParameterriskmanagement.vue?vue&type=script&lang=js"
export * from "./InputParameterriskmanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports